/**
 * Pure helpers for credit-transfer listings — extracted so the direction and
 * pagination logic can be unit-tested independently of the React components
 * that render them.
 */

/**
 * True when a transfer was SENT by `me` (outgoing), false when received.
 * Compares as strings so ObjectId vs string ids both work.
 */
export function isOutgoingTransfer(
   transfer: { from: string },
   me: string
): boolean {
   return String(transfer.from) === String(me);
}

export interface Paged<T> {
   pageRows: T[];
   totalPages: number;
   safePage: number;
   start: number;
}

/**
 * Slice `rows` for a 1-based `page`. Clamps the page into [1, totalPages] so an
 * out-of-range page (e.g. after the list shrinks) still returns a valid slice.
 * An empty list is 1 page with no rows.
 */
export function paginate<T>(
   rows: T[],
   page: number,
   pageSize: number
): Paged<T> {
   const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));
   const safePage = Math.min(Math.max(1, Math.floor(page) || 1), totalPages);
   const start = (safePage - 1) * pageSize;
   return {
      pageRows: rows.slice(start, start + pageSize),
      totalPages,
      safePage,
      start,
   };
}
